import { css } from 'styled-components';

export const baseOuter = css`
  max-width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 500px) {
    min-height: 700px;
    background-position: 0% top;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  background-position: 50%;
  background-size: cover;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  @media (max-width: 1024px) {
    background-position: 55%;
  }
`;

export const buttonCSS = css`
  display: flex;
  justify-content: flex-end;
`;

export const minWidthBaseOuter = css`
  min-height: 490px;
`;

export const textOverridesForBanners = css`
  h1 {
    margin: 0 0 12px 0;
  }
  h2,
  h3 {
    margin: 12px 0;
  }
  h4 {
    margin: 8px 0;
  }
  h5,
  h6,
  p {
    margin: 8px 0;
  }
  @media (max-width: 639px) {
    h1 {
      margin: 0 0 8px 0;
    }
    h2,
    h3 {
      margin: 8px 0;
    }
    h4,
    h5,
    h6,
    p {
      margin: 6px 0;
    }
  }
`;

export const outerLeft = css`
  justify-content: flex-start;
`;

export const outerRight = css`
  justify-content: flex-end;
`;

export const outerCenter = css`
  justify-content: center;
`;

export const outerCSS = {
  left: [baseOuter, outerLeft, minWidthBaseOuter],
  right: [baseOuter, outerRight, minWidthBaseOuter],
  center: [baseOuter, outerCenter, minWidthBaseOuter],
};

export const heroOuterCSS = {
  left: [baseOuter, minWidthBaseOuter],
  right: [baseOuter, minWidthBaseOuter],
  center: [baseOuter, minWidthBaseOuter],
};

export const baseWrapper = css`
  margin: 0 auto;
  max-width: 1200px;
  width: 100%;
`;

export const wrapperCSS = {
  left: [baseWrapper, outerLeft],
  right: [baseWrapper, outerRight],
  center: [baseWrapper, outerCenter],
};

export const innerLeft = css`
  max-width: 45%;
  min-width: 300px;
  padding-left: 10px;
  color: #ffffff;
  text-align: left;
  @media (max-width: 1024px) {
    max-width: 50%;
    min-width: unset;
    padding-left: 20px; // to line up with VF icon in top menu for tablet w2s.
  }
  @media (max-width: 640px) {
    max-width: unset;
    min-width: unset;
    padding-left: 10px;
    margin: 0 10px;
  }
`;

export const innerRight = css`
  max-width: 45%;
  min-width: 300px;
  padding: 0 10px;
  color: #ffffff;
  text-align: left;

  @media (min-width: 1930px) {
    margin-right: 10%;
  }
  @media (max-width: 1024px) {
    max-width: 48%;
    min-width: unset;
    padding: 0 20px; // tablet left-right margins for ws2.
  }
  @media (max-width: 640px) {
    width: 100%;
    max-width: unset;
    min-width: unset;
    padding: 0 10px; // mobile left-right margins for ws2
  }
`;

export const innerCenter = css`
  max-width: 60%;
  min-width: 300px;
  padding: 0 10px;
  color: #ffffff;
  text-align: center;

  @media (max-width: 1024px) {
    max-width: unset;
    min-width: unset;
    padding: 0 20px; // tablet left-right margins for ws2.
  }
  @media (max-width: 640px) {
    padding: 0 10px; // mobile left-right margins for ws2
  }
`;

export const innerCSS = {
  left: innerLeft,
  right: innerRight,
  center: innerCenter,
};

export const loadingOuterCSS = css`
  display: flex;
  height: 30px;
  width: 100px;
  @media (max-width: 500px) {
    height: 22px;
    width: 110px;
  }
`;

export const loadingInnerCSS = css`
  margin-right: 7px;
`;

export const formCSS = css`
  label {
    color: #fff;
    margin-top: 7px;
  }
  input {
    background-color: transparent;
    color: #fff;
    border-radius: 0px;
  }
`;